import React from "react";
import { FaBell, FaUserCircle, FaBars } from "react-icons/fa";
import GenerateSitemapButton from "../../utils/generateSitemap";
import { useSelector } from "react-redux";

function TopbarCom({ onMenuToggle }) {
  const { user } = useSelector((state) => state.userAuth);

  console.log(user, "user");
  return (
    <div className="bg-white shadow-md p-4 flex justify-between items-center">
      <FaBars
        className="text-xl cursor-pointer md:hidden"
        onClick={onMenuToggle}
      />
      <h1 className="text-xl font-bold">Flag Shop</h1>
      <div className="flex items-center gap-4">
        <FaBell className="text-xl text-gray-500 cursor-pointer hover:text-gray-700" />
        <FaUserCircle className="text-2xl text-gray-500 cursor-pointer hover:text-gray-700" />
      </div>
    </div>
  );
}

export default TopbarCom;
